import { Spinner } from "@components/ui/spinner";
import { zodResolver } from "@hookform/resolvers/zod";
import { endpoint } from "@services/api.services";
import { METHODS } from "@services/interface.service";
import { useQueryClient } from "@tanstack/react-query";
import { SkeletonTwo } from "@ui/external/components/skeleton";
import { getInputField } from "@utils/function/index.function";
import { showToast, throwErrorAlert } from "@utils/helper/index.helper";
import { useHandleAction, usePathname } from "@utils/hook/index.hook";
import { FormField } from "@utils/interface/form.interface";
import { BucketFormData, BucketSchema } from "@utils/interface/form.schema";
import { IndividualQuery } from "@utils/interface/index.interface";
import { BucketData, PopupFetchData } from "@utils/interface/journey.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { usePending, useSelectionStore } from "@utils/states/index.state";
import { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useSearchParams } from "react-router";

const BucketForm: React.FC = () => {
  const { handleAction } = useHandleAction({
    endpoint: endpoint[""],
  });
  const [searchParams] = useSearchParams();
  const pathname = usePathname();
  const queryClient = useQueryClient();
  const modalItem = searchParams.get("modal-item");
  const modalMode = searchParams.get("modal");
  let {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm<BucketFormData>({
    mode: "onChange",
    resolver: zodResolver(BucketSchema),
  });
  const { setIsFormPending, isFormPending } = useSelectionStore();

  const { data: fetchData, isPending: fetchPending } = useListData<
    IndividualQuery<BucketData>
  >({
    endpoint: endpoint["uploadimage"],
    key: `${pathname}-${modalItem}`,
    enabled: modalItem ? true : false,
    id: modalItem || "",
    window: false,
  });

  console.log(fetchData, "fetchData");
  /* set default value */
  const { setIsRetrive }: any = usePending();

  useEffect(() => {
    setIsRetrive(modalItem ? fetchPending : false);
    if (fetchData?.status === 200 && !fetchPending) {
      const firstResult = fetchData?.data;
      console.log(firstResult);
      if (firstResult) {
        if (modalMode == "add") {
          return reset({});
        } else {
          reset({
            ...firstResult,
          });
        }
      }
    }
  }, [fetchData?.data, fetchPending]);

  const handleMutate = (data: any) => {
    setIsFormPending(true);

    if (modalItem) {
      data = {
        ...data,
        id: modalItem,
      };
    }

    data = {
      ...data,
    };

    if (!(data.image instanceof File || data.image instanceof Blob))
      delete data.image;
    return {
      data,
      endpoint: endpoint["uploadimage"],
      method: modalItem ? METHODS.PUT : METHODS.POST,
    };
  };
  const handleSuccess = async ({
    status,
  }: {
    data: PopupFetchData;
    status: number;
  }) => {
    setIsFormPending(false);
    if ([200, 201].includes(status)) {
      setIsFormPending(false);
      queryClient.invalidateQueries({ queryKey: [`${pathname}-listing`] });
      showToast({
        description: `Bucket Data ${status === 200 ? "Updated" : "Created"}`,
        type: "success",
        title: "Success",
      });

      handleAction({
        type: "modal-close",
      });
    } else {
      return new Error("Unknown API Error");
    }
  };
  console.log("errors", errors);
  const handleError = async (error: any) => {
    console.log(error.data.data, "error00");
    setIsFormPending(false);
    if (error?.data?.status == 413) {
      showToast({
        description: "File Size Too Large",
        type: "error",
        title: "Error",
      });
    }

    throwErrorAlert(error.data.data);
  };

  const { mutate } = usePostData();

  /** =========================================== Invoice Course List api ==================================================== **/

  // const {} = useListData({
  //   endpoint: endpoi
  // })

  /** =============================================================================================== **/

  const onSubmit: SubmitHandler<BucketFormData> = (data) => {
    //Add Mutation Data

    mutate(handleMutate(data), {
      onSuccess: ({ data, status }) => handleSuccess({ data, status }),
      onError: (data) => handleError({ data }),
    });
  };

  const formSchema: FormField[] = [
    {
      name: "image",
      label: "Add Image To Bucket",
      colSpan: 12,
      type: "fileupload",
      placeholder: "Enter ",
      control: control,
      setValue: setValue,
      allowCopy: true,
      errors,
      className: `mb-[20px] min-w-full  w-full`,
      visable: true,
    },
    {
      type: "submit",
      value: "Submit",
      className: "w-full h-[47px] mt-[32px] capitalize",
      colSpan: 12,
      variant: "default",
      endIcon: isFormPending ? <Spinner /> : null,
      disabled: isFormPending ? true : false,
      visable: modalMode == "add" ? true : false,
    },
  ];

  if (fetchPending && modalItem)
    return (
      <>
        <SkeletonTwo />
      </>
    );

  return (
    <>
      <form
        id={pathname}
        onSubmit={handleSubmit(onSubmit)}
        className="row w-full"
      >
        <div className="w-full col-lg-12">
          <div className="row">
            {formSchema.map(
              (field, index) =>
                (field.visable || field.visable == undefined) && (
                  <div
                    key={index}
                    className={`col-lg-${field.colSpan} col-12  lg:px-[12px] px-[8px]`}
                  >
                    {getInputField({ ...field })}
                  </div>
                )
            )}
          </div>
        </div>
      </form>
    </>
  );
};
export { BucketForm };
